import React from "react";

import { FlexJustify } from "common/fragments/Flex";
import { BlockView } from "common/views/block/BlockView.view";
import { ImageVariant, ImageView } from "common/views/image/Image.view";
import { MenuTreeVariant } from "common/views/menuTree/MenuTree.view";
import NavMenu from "common/views/menuTree/NavMenu";
import { IPanelProps, Panel } from "core/decorators/Panel";
import labelProvider from './Header.labels';
import HeaderConfig from "./HeaderConfig";

interface IHeaderState {
	expanded: { [id: string]: boolean; };
}

@Panel({id: "header", configClass: HeaderConfig, labelProvider})
class HeaderPanel extends React.Component<IPanelProps<HeaderConfig>, IHeaderState> {

	public state = { expanded: {} };

	public render() {
		const { config } = this.props;


		return (
			<BlockView viewKey="header-block">
				<FlexJustify>
					<div>
						<a href={config.logoLink} aria-label="Link to Homepage" target={config.openInNewTab ? "_blank" : "_self"}>
							{config.logoUrl && <ImageView style={{maxWidth: config.logoWidth }} variant={ImageVariant.LOGO} viewKey="logo" src={config.logoUrl} />}
						</a>					
					</div>
					<div>
						{
							config.toolbar && config.toolbar.data && (
								<NavMenu
									expanded={this.state.expanded}
									menu={config.toolbar}
									onExpandChange={this.onExpand}
									variant={MenuTreeVariant.TOOLBAR}
									viewKey="toolbar"
								/>
							)
						}
					</div>
				</FlexJustify>
			</BlockView>
		);
	}

	private onExpand = (id: string, isExpanded: boolean) => {
		this.setState({
			expanded: {...this.state.expanded, [id]: isExpanded}
		});
	}
}



// WEBPACK FOOTER //
// ./src/panels/header/Header.panel.tsx